import { render, staticRenderFns } from "./LifeSchool.vue?vue&type=template&id=35a40c12"
import script from "./LifeSchool.vue?vue&type=script&lang=js"
export * from "./LifeSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports